module.exports = __webpack_public_path__ + "img/order_list.f0efbfab.svg";